<template>
    <a-modal v-model="visible" title="" onOk="handleOk" width="750px" @cancel="$emit('close')">
        <template slot="footer">
            <a-button key="back" @click="$emit('close')">Cancel</a-button>
            <a-button key="submit" style="background-color:#20409a; color: #fff" :loading="loading" @click="schedule">
                schedule
            </a-button>
        </template>
        <div class="mt-4">
            <h4 class="font-weight-bolder text-left kova-text">
                Schedule Live Interview Exercise
            </h4>
            <p class="text-left">
                Your live interview exercise carries 50% of your vetting ﬁnal evaluation. Ensure you put in your best.
            </p>
            <h6 class="font-weight-bolder text-left">Instructions</h6>
            <div class="row">
                <div class="col-1 text-right">
                    <font-awesome-icon class="kova-text" style="font-size:10px" icon="circle"></font-awesome-icon>
                </div>
                <div class="col">
                    <p class="text-left">Be available 20mins before the interview</p>
                </div>
            </div>
            <div class="row">
                <div class="col-1 text-right">
                    <font-awesome-icon class="kova-text" style="font-size:10px" icon="circle"></font-awesome-icon>
                </div>
                <div class="col">
                    <p class="text-left">
                        Every part of thes exercise requires only your presence and input. Avoid every form of
                        distraction
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-1 text-right">
                    <font-awesome-icon class="kova-text" style="font-size:10px" icon="circle"></font-awesome-icon>
                </div>
                <div class="col">
                    <p class="text-left">
                        In case of unavailability, notify and reschedule the interview at least 24hrs before the set
                        time, failure to notify on time will result to overall score reduction penalty (up to 10%)
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-1 text-right">
                    <font-awesome-icon class="kova-text" style="font-size:10px" icon="circle"></font-awesome-icon>
                </div>
                <div class="col">
                    <p class="text-left">
                        You will received full interview instructions 2 course before it commence.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-1 text-right"></div>
                <div class="col"><p class="text-left">Good Luck!</p></div>
            </div>
            <hr />
            <h4 class="font-weight-bolder text-left kova-text">Set Date and Time</h4>
            <div class="my-3">
                <span class="bg-light px-2 py-2 rounded font-weight-bolder" v-if="date">
                    {{ interviewDate | dateOnly }}
                </span>
                <span class="bg-light px-2 py-2 rounded font-weight-bolder ml-3" v-if="time">
                    {{ time | timeOnly }}
                </span>
                <span class="bg-light px-2 py-2 rounded font-weight-bolder ml-3" v-if="timezone">
                    {{ timezone }}
                </span>
            </div>
            <div id="interview" class="row">
                <div class="col-12 col-md-6">
                    <div
                        :style="{
                            width: '300px',
                            border: '1px solid #d9d9d9',
                            borderRadius: '4px',
                        }"
                    >
                        <a-calendar
                            :fullscreen="false"
                            @select="onSelect"
                            @panelChange="onPanelChange"
                            :disabledDate="disabledDate"
                        />
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="mt-4 flex">
                        <label class="mr-2">Pick a time: </label>
                        <a-time-picker v-model="time" use12Hours class="w-50" format="h:mm a" @change="getTime" />
                    </div>
                    <!-- <div class="mt-3 mt-md-5">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span
                  ><a-icon
                    type="info-circle"
                    style="position:relative; bottom: 3px;font-size: 16px;"
                  />
                  Click to copy to artboard</span
                >
              </template>
              <span class="kova-id px-3 py-2 text-white font-weight-bolder"
                >Call ID: Kovatek.id.2245</span
              >
            </a-tooltip>
          </div> -->

                    <div class="mt-4 flex">
                        <label class="mr-2">Pick a timezone: </label>
                        <a-select v-model="timezone" class="w-50">
                            <a-select-option :value="zone" :key="zone" v-for="zone in timezones">
                                {{ zone }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <!-- <a -->
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import moment from 'moment';
import moment_tz from 'moment-timezone';

import countries from '../../data/countries.json';

export default {
    data() {
        return {
            time: null,
            date: null,
            interviewDate: Date.now(),
            timezone: null,
            loading: false,
            // time: Date.now(),
        };
    },
    computed: {
        timezones() {
            const country = countries.find(key => key.name === this.profileData.Country);
            if (!country) return [];

            return moment_tz.tz.zonesForCountry(country.iso2);
        },
        disabledDate() {
            return current => {
                return moment().add(-1, 'days') >= current || moment().add(1, 'month') <= current;
            };
        },
    },
    props: {
        visible: Boolean,
        profileData: Object,
    },
    methods: {
        onSelect(value) {
            this.date = value;
            this.interviewDate = value;
        },
        onPanelChange(value) {
            // console.log(value, mode);
            this.date = value;
            this.interviewDate = value;
        },
        getTime(time) {
            // console.log(time, timeString);
            this.time = time;
        },
        schedule() {
            let { date, time, timezone } = this;
            const isToday = date ? moment(date).isSameOrBefore() : false;

            // const twoWeeks = moment().add(14, 'days').startOf('day');
            // const isWithinTwoWeeks = moment(date).isAfter(twoWeeks)

            const error = !date
                ? 'Please select a suitable date for the interview'
                : isToday
                ? 'Please set a later date than the date you picked'
                : !time
                ? 'Please pick a suitable time for the interview'
                : !timezone
                ? 'Please select your timezone'
                : '';

            if (error.length) return this.showError('', error);

            date = String(new Date(this.date)).slice(0, 15);
            time = String(new Date(this.time)).slice(15);
            const dateTime = new Date(date + time);

            const start_time = dateTime.toISOString(),
                end_time = moment(dateTime)
                    .add(1, 'hours')
                    ._d.toISOString();

            const title = `${this.profileLevel} ${this.profileTitle} Interview`;
            const description = this.strip_html_tags(this.profileData.AboutMe);
            this.submitDetails({ title, description, start_time, end_time, timezone });
        },
        async submitDetails(data) {
            this.loading = true;
            const token = localStorage.getItem('token');
            try {
                const res = await this.$api({
                    url: `/interviews`,
                    method: 'post',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    data,
                });
                this.loading = false;
                this.$emit('done', res.data);
            } catch (err) {
                this.loading = false;
                this.catchErrors(err);
                // console.log(err)
            }
        },
        strip_html_tags(str) {
            if (str === null || str === '') return false;
            else str = str.toString();
            return str.replace(/<[^>]*>/g, '');
        },
    },
};
</script>
